import { useState, useEffect } from 'react';

const useTimeout = (delay) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (delay === null) return;

    const timeout = setTimeout(() => {
      setShow(true);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);

  return show;
};

export default useTimeout;
